import React, { useMemo, useEffect, useState } from 'react'
import './header.css'
import Offer from '../../offer/offer'
import Score from '../../score/score'
import HeaderScore from './headerscore'
import { NoImage } from '../../../constants'
import { isMobile } from 'react-device-detect';
import { QueryReview } from '../../../constants'
import data from '../content/data.json'
import { ContentProps } from '../content/constants';

type Props = {
    site: string,
    rank: number,
    sitelink: string,
    offertext: string,
    score: number
}
function ReviewHeader(props: Props) {
    const [headingText, setHeadingText] = useState("");
    const [subHeadingText, setSubHeadingText] = useState("");

    const logo = useMemo(() => {
        try {
            if (isMobile) {
                return require(`../../../../images/main/sites-logo/review/mobile/${props.site.toLowerCase()}.png`)
            }
            else {
                return require(`../../../../images/main/sites-logo/review/${props.site.toLowerCase()}.png`)
            }
            
        } catch (error) {
            return NoImage
        }
    }, [props])

    
    useEffect(() => {
        const _filtered = data.filter(d => d.site.toLowerCase() === props.site.toLowerCase());
        if (_filtered.length === 0) {
            return
        }
        setHeadingText(_filtered[0].reviewHeading || "");
        setSubHeadingText(_filtered[0].reviewSubHeading || "");
    }, [props.site])


    return (
        <section className={`review-header position-relative border-box bg-white ${!isMobile ? 'desktop-content-width' : 'mobile-content-width'} site-${props.site.toLowerCase()}`}>
            <div className='review-header-site-wrapper'>
                {!isMobile
                ? <img className='d-block' src={logo} alt={props.site} />
                : <div className='mobile-logo-wrapper'>
                    <img className='d-block' src={logo} alt={props.site} />
                    {props.site.toLowerCase() != "allcamsex"
                    ? <img className='d-block' src={require("../../../../images/main/sites-logo/review/mobile/allcamsex.png")} alt="allcamsex" />
                    : null
                    }
                </div>
                }
                <HeaderScore score={props.score} />
            </div>
            <div className='review-header-offer-wrapper'>
                <div className='review-header-offer-text-wrapper'>
                    <span className='review-header-offer-heading'>{headingText}</span>
                    <span className='review-header-offer-subheading'>{subHeadingText}</span>
                </div>
                <Offer rank={props.rank} link={props.sitelink} text={props.offertext} site={props.site} query={QueryReview} isReviewPage={true} />
            </div>
        </section>
    )
}
export default ReviewHeader


{/* <section className={`review-header d-table position-relative w-inherit border-box bg-white ${!isMobile ? 'desktop-content-width' : 'mobile-content-width'} site-${props.site.toLowerCase()}`}>
        <div className='img-cont d-table position-relative float-left'>
            <img className='d-block' src={logo} alt={props.site} />
            <h1 className='F16 margin-top-10 color-grey sitename'>{props.site} Review</h1>
        </div>
        <div className='position-relative d-table float-left background second-row'>
            <div className='position-relative offer-cont float-left d-table'>
                <Offer rank={props.rank} link={props.sitelink} text={props.offertext} site={props.site} query={QueryReview} />
            </div>
            <div className='position-relative score-wrapper float-left d-table'>
                <Score score={props.score} />
            </div>
        </div>
    </section> */} 